import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';

const HomePage = ({ selectedCity }) => {
  const [featuredFirms, setFeaturedFirms] = useState([]);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const loadData = async () => {
      const [firms, cats] = await Promise.all([
        api.getFeaturedFirms(selectedCity),
        api.getCategories()
      ]);
      setFeaturedFirms(firms);
      setCategories(cats);
    };
    loadData();
  }, [selectedCity]);

  const heroStyle = {
    background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
    color: 'var(--white)',
    padding: '80px 0',
    textAlign: 'center'
  };



  const categoryGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px',
    marginTop: '40px'
  };

  const categoryCardStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '32px 24px',
    textAlign: 'center',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    border: '2px solid transparent'
  };

  const categoryIconStyle = {
    fontSize: '48px',
    marginBottom: '16px',
    display: 'block'
  };

  const sectionTitleStyle = {
    fontSize: '32px',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: '16px',
    color: 'var(--navy-blue)',
    fontFamily: 'Comfortaa, cursive'
  };

  const sectionSubtitleStyle = {
    fontSize: '18px',
    textAlign: 'center',
    color: 'var(--gray-600)',
    marginBottom: '40px'
  };

  return (
    <div>
      {/* Hero Section */}
      <section style={heroStyle}>
        <div className="container">
          <h1 style={{ fontSize: '48px', marginBottom: '20px', fontFamily: 'Comfortaa, cursive' }}>
            Kolay Servis'e Hoş Geldiniz
          </h1>
          <p style={{ fontSize: '20px', marginBottom: '30px', opacity: 0.9 }}>
            {selectedCity ? `${selectedCity} şehrindeki` : 'Türkiye\'deki'} en iyi işletmeleri keşfedin
          </p>
          <Link to="/firma-ekle" className="btn btn-secondary" style={{ fontSize: '18px', padding: '16px 32px' }}>
            Firmanızı Ekleyin
          </Link>
        </div>
      </section>

      <div className="container">
        {/* Featured Firms Multi-Slider */}
        {featuredFirms.length > 0 && (
          <section style={{ marginTop: '60px' }}>
            <h2 style={sectionTitleStyle}>Öne Çıkan Firmalar</h2>
            <p style={sectionSubtitleStyle}>
              {selectedCity ? `${selectedCity} şehrindeki` : ''} en popüler işletmeler
            </p>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px',
              marginBottom: '40px'
            }}>
              {featuredFirms.map((firm) => (
                <div 
                  key={firm.id}
                  style={{
                    background: 'linear-gradient(45deg, var(--navy-blue), var(--baby-blue))',
                    borderRadius: '12px',
                    padding: '24px',
                    color: 'var(--white)',
                    textAlign: 'center',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <h3 style={{ fontSize: '20px', marginBottom: '12px', fontFamily: 'Comfortaa, cursive' }}>
                    {firm.title}
                  </h3>
                  <p style={{ fontSize: '14px', marginBottom: '16px', opacity: 0.9, lineHeight: '1.4' }}>
                    {firm.services.length > 80 ? firm.services.substring(0, 80) + '...' : firm.services}
                  </p>
                  <div style={{ marginBottom: '16px' }}>
                    <span style={{ fontSize: '16px' }}>⭐ {firm.puan}</span>
                    <span style={{ fontSize: '12px', opacity: 0.8, marginLeft: '8px' }}>({firm.yorumlar?.length || 0} yorum)</span>
                  </div>
                  <Link 
                    to={`/firma/${firm.id}`} 
                    className="btn btn-secondary"
                    style={{ fontSize: '14px', padding: '8px 16px' }}
                  >
                    Detaylar
                  </Link>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Categories Section */}
        <section style={{ marginTop: '80px', marginBottom: '60px' }}>
          <h2 style={sectionTitleStyle}>Kategoriler</h2>
          <p style={sectionSubtitleStyle}>
            İhtiyacınız olan hizmeti kategoriler arasından seçin
          </p>
          
          <div style={categoryGridStyle}>
            {categories.map(category => (
              <Link 
                key={category.id}
                to={`/kategori/${category.id}`}
                style={{ textDecoration: 'none' }}
              >
                <div 
                  style={categoryCardStyle}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-8px)';
                    e.target.style.borderColor = 'var(--baby-blue)';
                    e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.borderColor = 'transparent';
                    e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                  }}
                >
                  <span style={categoryIconStyle}>{category.icon}</span>
                  <h3 style={{ 
                    fontSize: '20px', 
                    marginBottom: '12px',
                    color: 'var(--navy-blue)',
                    fontFamily: 'Comfortaa, cursive'
                  }}>
                    {category.name}
                  </h3>
                  <p style={{ color: 'var(--gray-600)', fontSize: '14px' }}>
                    Bu kategorideki firmaları görüntüle
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;